export default {
  title: {
    login: "%{school} - Login",
    registration: "%{school} - Registration",
    subjects: "%{school} - Select subject",
    subject: "%{school} - Subject",
    offer: "%{school} - Offer",
    home: "%{school} - Dashboard",
    dictionary: "%{school} - Dictionary",
    events: "%{school} - Events",
    news: "%{school} - News",
    profile: "%{school} - Profile",
    learn: "%{school} - Learning",
    pay: "%{school} - Subject purchasing",
    checkInSystem: "Are you already registered?",
    setPassword: "Enter password to login.",
    createAccount: "Create an account in the system.",
  },
  authCheckEmail: {
    title: "Enter your email address",
    emailCaption: "Email",
    continue: "Continue",
    or: "or",
  },
  authPassword: {
    title: "Log in to your account",
    inputCaption: "Passcode",
    placeholder: "Enter your password",
    forgot: "Forgot your password?",
    submit: "Log in",
  },
  authRegistration: {
    title: "Account registration",
    name: "Name",
    phone: "Phone number",
    password: "Come up with a password",
    confirmPassword: "Repeat the invented password",
  },
  totalError: "Oops, something went wrong!",
  subjectChangeError: "Unable to switch subject. Please try again or contact your school.",
  email: "Email",
  personalLink: "Personal link",
  login: "Login",
  name: "Name",
  firstLastName: "Surname and first name",
  phone: "Phone",
  formatPhone: "Phone number in the format 998...", // for leader-online
  aboutMe: "About me",
  fullAge: "Your age (full years)",
  errorAge: "Incorrect age",
  notNumber: "Value must be a number",
  registration: "Registration",
  password: "Password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  confirmNewPassword: "Confirm new password",
  forgotPassword: "Forgot your password?",
  passwordsMatch: "Passwords do not match",
  resetPassword: "Password reset successfully, check your email for details.",
  resetConfirm: "Do you want to reset your password?",
  enter: "Enter",
  studentEnter: "Student enter",
  check: "Check",
  signInWithGoogle: "Sign in with Google",
  emailIsNotRegistered: "Email is not Registered",
  logout: "Logout",
  online: "online",
  offline: "offline",
  cancel: "Cancel",
  stop: "Stop",
  no: "No",
  course: "Course",
  dictionary: "Dictionary",
  events: "Events",
  news: "News",
  words: "Words",
  wordsAreHere: "These words are here:",
  allWords: "All words",
  phrases: "Phrases",
  videos: "Videos",
  exercises: "Exercises",
  theory: "Theory",
  theoryAlt: "Notes",
  theoryAdditionalFile: "Download additional file (%{filename})",
  topic: "Topic",
  lesson: "Lesson",
  lessons: "Lessons",
  profile: "Profile",
  orders: "Orders",
  payment: "Payment",
  leaderboard: "Leaderboard",
  leaderboardPerDay: "Today's leaders",
  time: "Time",
  points: "Points",
  myPoints: "My points for the whole period",
  coins: "Coins",
  courses: "My Courses",
  loading: "Loading...",
  noTheory: "No theory available for this lesson",
  startTraining: "Start Training",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Start a chat",
    startDialogTooltip: "Start new conversation",
    messages: "Messages",
    unreadOnly: "Unread only",
    delete: "Delete",
    send: "Send",
    sendHelper: "Ctrl+Enter to send a message",
    close: "Close",
    profile: "Profile",
    lastActivity: "Last activity",
    status: "Status",
    jobTitle: "Job title",
    tabLabel: "Chat",
    lastOnline: {
      time: "Last seen at %{date}",
      weekday: "Last seen on %{date}",
      dayMonth: "Last seen on %{date}",
      monthYear: "Last seen in %{date}",
    },
    read: "Read",
    errors: {
      wrongFormatting: "Message contains wrong formatting",
    },
  },
  branches: "Topics",
  easy: "Easy",
  expert: "Expert",
  wordToLearn: "Word to learn",
  iKnowWord: "I know this word",
  videoVocabulary: "Video Vocabulary",
  markVideoWatched: "Mark as watched",
  videoWatched: "Watched",
  passed: "passed",
  unsupportedExercise: "Unsupported exercise (%{type})",
  changeCourse: "Change course",
  currentCourse: "Current course",
  allSubjects: "All subjects",
  all: "All",
  subject: "Subject",
  group: "Group",
  start: "Start",
  chooseSubject: "Choose the subject you would like to study",
  hourValue: "%{value} h",
  completed: "Completed",
  notCompleted: "Not completed",
  paidBranch: "This branch is paid. Please purchase it to study.",
  buyBranch: "Buy branch for %{price} %{currency}",
  paidSubject: "This subject is paid. Please purchase it to study.",
  buySubject2: "Buy subject for %{price} %{currency}",
  decksItemNotOpen: "To open this lesson, you need to pass the previous lesson",
  decksItemNotPurchasedBranch: "The topic of this lesson is blocked",
  decksItemNotOpenLevel: "You have to pass a previous level in order to open this lesson",
  decksItemNotOpenBranch: "To open this lesson, you need to pass the previous topic",
  deckAccessDenied: "This lesson is not yet available to you",
  openOnDate: "will open on %{date}",
  levelAccessIsDenied: "This level materials are not available to you",
  youAreDeactivated: "Your account has been deactivated, please contact your school",
  youAreDeactivatedShort: "Your account is deactivated",
  youAreHaveNotPaidOffers: "You are have unpaid offers",
  yourCertificates: "Your certificates",
  emptyDeck: "Deck is Empty",
  nextDeck: "Next lesson",
  next: "Go on",
  proceed: "Proceed",
  skip: "Skip",
  more: "More",
  exit: "Exit",
  details: "See details",
  go: "Go",
  profileEdit: "Edit user's profile",
  userInfo: "User info",
  of: "of",
  back: "Back",
  levelPackExist: "You already have this set of levels",
  awaitingPayment: "Awaiting payment",
  bought: "Bought",
  boughtUntilDate: "Bought until  %{endDate}",
  availableUntilDate: "Available until  %{endDate}",
  showMore: "show more",
  hide: "hide",
  communication: "Contact us",
  askQuestion: "Ask a question",
  noDescription: "Description missing",
  description: "Description:",
  onePerMonth: "Subscribe for a month",
  semiannually: "Subscribe for six months",
  onceAYear: "Subscribe for a year",
  stopSubscribe: "Stop Subscribe",
  enable: "Enable Subscribe",
  expired: "Expired",
  buySubject: "Buy Subject",
  buyOffer: "Buy",
  subscribeOffer: "Subscribe offer",
  firstPayment: "First payment",
  accessDaysWarning: "%{smart_count} day left |||| %{smart_count} days left",
  accessDemoDaysWarning: "Demo: %{smart_count} day left |||| Demo: %{smart_count} days left",
  accessDemoButton: "Demo access",
  closeButton: "Close",
  existOffer: "There is already an unpaid offer",
  loginInProcess: "logging in process...",
  done: "Completed:",
  Levels: {
    empty: "There are no available levels in this course yet.",
    name: "Level:",
  },
  Decks: {
    scormPass: "Credit a lesson",
    proceed: "Proceed",
    stayHere: "Stay here",
  },
  Exercises: {
    tabTitle: "Exercises",
    skip: "Next",
    check: "Check",
    examCheck: "Send",
    typeAnswer: "Type your answer",
    next: "Go on",
    rightAnswerWas: "The correct answer was:",
    showRightAnswer: "Show correct answer",
    rightAnswer: "Correct answer:",
    congratulation: "Congratulation!",
    congratText: "You have learned all exercises in this lesson!",
    wrongAnswer: "Your answer is wrong",
    answerSaved: "Answer saved",
    commentToAnswer: "Comment to selected answer:",
    appendix: {
      pdf: {
        tooltipButton: "Additional stuff",
      },
    },
    type13: {
      title: "Fill in the gaps by selecting the correct word from the drop-down list",
    },
    type12: {
      title: "Find out more information",
    },
    type11: {
      title: {
        select: "Choose the right answer",
        keyboard: "Write the right answer",
      },
    },
    type9: {
      title: {
        select: "Fill in the gaps by choosing words",
        keyboard: "Fill in the gaps",
      },
    },
    type8: {
      title: "Find matches",
    },
    type7: {
      title: {
        text: "Write your answer",
        audio: "Record your answer",
      },
      recordingIsNotSupported: "Audio recording is not supported",
      audioRecordingError: "The following getUserMedia error occurred: ",
      inputLabel: "Message",
      addPhotoVideo: "Add photo/video (max 5)",
      addPhoto: "Add photo (max 5)",
      cameraInitialization: "Initialization...",
      change: "Change",
      codeToApprove: "Password",
      homework: {
        teacherData: {
          audio: "Audio teacher's comment",
          audioComment: "Voice teacher's comment",
        },
      },
      addFiles: "Add files",
      limitsHelperText: "The text length must be at least %{count} letters",
      photoRequired: "Attach at least one photo or file to your answer",
      photoViewerHint: "You can zoom the image with the mouse wheel",
    },
    type6: {
      title: "Draw letter",
      checkButtonText: "Got it!",
    },
    type3: {
      title: "Drag&Drop the elements in order",
      hint: "Drag here items placed below",
    },
    type5: {
      title: "Select elements",
      hint: "Select the correct elements from the bottom of the screen (to choose - just click on them)",
    },
    type2: {
      title: "Choose the missing element",
    },
  },
  Events: {
    headNotice: "The event time is displayed according to your time zone",
    title: "This week's events",
    startTime: "Start time",
    finishTime: "End time",
    group: "Group",
    persons: "%{smart_count} person |||| %{smart_count} persons",
    leader: "Leader",
    tag: "Tag",
    joinedCheckbox: "Only Joined",
    joined: "Joined:",
    interested: "Registration",
    registered: "Registered",
    enter: "Enter",
    limitPopupInfo: "You have reached the registration limit",
    eventHasStarted: "The event has already started!",
    registrationNotice: "You have successfully registered! The enter button will be active at %{date_and_time}. After this time you will not be able to cancel the event registration",
    registrationNoticeNoUrl: "You have successfully registered! After %{date_and_time} you will not be able to cancel the event registration",
    cancelRegistration: "Do you really want to cancel the registration?",
    calendarLink: "Add Event to Google Calendar",
    status_planned: "Planned",
    status_started: "Started",
    status_completed_successfully: "Completed",
    status_last_minute_cancellation: "Last minute cancellation",
    status_late_cancellation: "Late cancellation",
    status_canceled: "Canceled",
    status_moved: "Moved",
  },
  statistic: {
    title: "Statistics",
    points: "points",
    phrases: "phrases",
    missions: "missions",
    words: "words",
    time: "time",
  },
  status: {
    wait_review: "To be reviewed",
    on_review: "Reviewing",
    approved: "Approved",
    not_approved: "Not Approved",
    not_approved_allow_update: "Not Approved (allow edit)",
    ai_reviewed: "Checked with AI",
  },
  homeworks: {
    tabName: "Homeworks",
    todo: "To do",
    done: "Done",
    topic: "Topic",
    lesson: "Lesson",
    onlyInMobileApp: "Available only in a mobile application",
    todoHomework: "PENDING HOMEWORK",
    postToDoButton: "Send",
    types: {
      homework_todo: "ToDo",
      exercise: "Exercise",
    },
    waitAIReview: "Please wait, AI is checking the answer",
    dontWait: "don't wait",
    checkingHomework: "Checking homework",
  },
  exam: {
    popupTitle: "Lesson with exam",
    popupDescr1: "This is a lesson with an exam. First, study all the additional materials and only then proceed to the exercises.",
    popupDescr2: `As soon as you go to the "Exercises" tab, the countdown will begin.`,
    popupDescr3: 'The "Theory" and "Video" tabs do NOT start the exam countdown.',
    cancelButton: "Next time",
    positiveButton: "I understand (%{smart_count} attempt)  |||| I understand (%{smart_count} attempts)",
    questions: "%{smart_count} question |||| %{smart_count} questions",
    oneAttempt: "One try per question",
    timeLimit: "Limited time: %{limit} min",
    noPause: "The exam cannot be paused",
    progress: "Question #%{current} of %{total}",
    closeButton: "Close",
    viewButton: "View results",
    retakeButton: "Try again (%{smart_count} attempt)  |||| Try again (%{smart_count} attempts)",
    finishedPopupTitle: "Final score",
    examPassed: "Exam passed",
    examNotPassed: "Exam not passed",
    waitHomeworks: "%{smart_count} question on review |||| %{smart_count} questions on review",
    result: "Your result:",
  },
  subjects: {
    unavailable: "The subject is currently unavailable",
  },
  orderStatus: {
    approved: "Approved",
    canceled: "Canceled",
    pending: "Pending",
  },
  notificationsTypes: {
    event: "event",
    invoice: "invoice",
    news: "news",
    homework: "homework",
    homework_todo: "homework_todo",
    type: {
      exercise: "Homework",
      homework_todo: "Homework To do",
    },
  },
  notificationsAlert: {
    subscribe: "Turn on notifications",
    unsubscribe: "Turn off notifications",
    instructions: "Click the 🔒 lock to the left of the address bar and change the notification resolution as shown in the image or change your general browser settings.",
    permissionDefault: {
      title: "Subscribe to notifications 🔔",
      body: "Alerts on Homework status change, event start, news, new task to execute. No ads, just notifications about your learning!",
    },
    permissionDenied: {
      title: "Notifications are now turned off ❌",
      body: "You have previously turned off notifications. Without them, you can not know in time about a change in the status of the Homework, the beginning of the event. To turn on notifications, follow the instructions below:",
    },
    permissionGranted: {
      title: "Notifications are now enabled ✔",
      body: "Are you sure you want to opt out of notifications? Without them, you can't know in time about a change in the status of a Homework, the start of an event. To turn off notifications, follow the instructions below:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Send feedback",
    placeholder: "Tell us about your impressions",
    defaultInstruction: "Use the slider to evaluate",
    eventInstruction: "Rate how the event went",
    submitError: "Please select a rating",
    submitSuccess: "Thank you! Your feedback has been successfully sent",
    wasNotPresent: "I did not attend the event",
    dateOfEvent: "Date of the event:",
  },
  congratulation: {
    mission: "Congratulations, %{name} mission is complete!",
    missionTask: {
      title: "🎉 Congratulations! Task %{name} completed.",
      content: "<b>%{need} tasks</b> left to finish the mission — keep up the great work!",
    },
  },
  accountNotFound: "This email address is not associated with any learning space. Contact your school administrator",
  demoAccess: "Want to try SkillzRun for your business/school? Sign up to test the platform",
  structure: "Structure",
  version: {
    message: "A new version of the application is available. Please reload the page to update",
    button: "Reload",
  },
  missions: {
    title: "Missions",
    startButton: "Start mission",
    missionStarted: "Mission started %{started}",
    started: "Mission started!",
    tasks: {
      title: "Task Details",
    },
  },
  productCatalog: {
    title: "Product catalog",
    coinBalance: "Your balance:",
    notEnoughCoins: "Not enough coins",
    order: "Order",
    orderConfirmation: "Order confirmation",
    price: "Price:",
    remaining: "Remaining:",
    instructionForForm: "To speed up the processing of your order, please fill in the details for delivery.",
    address: "Address",
    thankText: "Thank you! Your order has been placed.",
    pleaseWait: "Please wait, a manager will contact you shortly.",
    pleaseWaitPersona: "Please wait for an SMS; you will receive your tracking number.",
    thankTextOffer: "Thank you! Your purchase has been completed",
    contentAvailableText: "The content is already available — you can use it right now.",
    deliveryAddress: "Enter your delivery address",
    helperText: "Please provide the full address or city and branch number of Nova Poshta/Ukrposhta.",
    deliveryOptions: "*Delivery options will be confirmed with the manager after receiving the order.",
    validationPhoneFormat: "Phone number must contain 10 digits and start with 0.",
    recipientNameLabel: "Full name",
    recipientNameRequired: "Please enter the recipient's name.",
    npCityRequired: "Please select a delivery city.",
    npWarehouseRequired: "Please select a Nova Poshta branch.",
    npCityLabel: "Nova Poshta city",
    npCityPlaceholder: "Start typing the city name",
    npCitySearching: "Searching cities...",
    npCitySelectHint: "Select a city from the list",
    npCityTypeHint: "Start typing the city name (min. 3 characters)",
    npBranchTypeDepartments: "Branches",
    npBranchTypePostomats: "Postomats",
    npWarehouseLabel: "Nova Poshta branch",
    npWarehousePlaceholder: "Select a branch",
    npWarehouseLoading: "Loading branches...",
    npWarehouseSelectHint: "Select a branch from the list",
    npWarehouseEmpty: "No branches found for this city",
    npWarehouseCityFirst: "Select a city first",
    inProcessing: "In processing",
    purchased: "Purchased",
    oneTimeAlreadyPurchased: "This item has already been purchased",
  },
  companyReviewTitle: "How likely are you to recommend our school to a friend or acquaintance?",
  companyReviewText: 'Rate on a scale of 1 to 10, where 1 means "not at all likely" and 10 means "very likely"',
  subjectReviewTitle: "How interesting was it for you to take this course on the platform?",
  subjectReviewText: 'Rate on a scale of 1 to 10, where 1 means "not at all interesting" and 10 means "very interesting"',
  policySettings: {
    termsAndConditions: "Terms and Conditions",
    refund: "Privacy Policy",
  },
  lessonsCount_one: "%{smart_count} lesson",
  lessonsCount_few: "%{smart_count} lessons",
  lessonsCount_many: "%{smart_count} lessons",
  promoCode: "Promo code",
  promoInvalid: "The promo code is invalid",
};
